<template>
  <div>
    <v-tabs v-model="tab">
      <v-tabs-slider />
      <v-tab
        v-for="(swr, k) in data"
        :key="k"
      >
        PubChem CID {{ swr.cid }}
        <a
          :href="`https://pubchem.ncbi.nlm.nih.gov/compound/${swr.cid}`"
          target="_blank"
          class="ml-2"
        >
          <img
            :src="`https://pubchem.ncbi.nlm.nih.gov/image/imgsrv.fcgi?cid=${swr.cid}`"
            :alt="`PubChem image for CID ${swr.cid}`"
          />
        </a>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item
        v-for="(swr, l) in data"
        :key="l"
      >
        <PubchemSections
          :section="swr.section"
          :references="swr.references"
        />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import PubchemSections from '@/components/pubchem/PubchemSections.vue'

export default {
  components: { PubchemSections },
  props: {
    result: {
      type: Object,
      mandatory: true,
    },
  },
  data: () => ({
    tab: 0,
  }),
  computed: {
    data() {
      return [...this.result.swr].sort((f1, f2) => f1.cid - f2.cid)
    },
  },
}
</script>
